import { render, staticRenderFns } from "./previewMobile.vue?vue&type=template&id=dcfeb7c6&scoped=true&"
import script from "./previewMobile.vue?vue&type=script&lang=js&"
export * from "./previewMobile.vue?vue&type=script&lang=js&"
import style0 from "./previewMobile.vue?vue&type=style&index=0&id=dcfeb7c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfeb7c6",
  null
  
)

export default component.exports